module.exports = __webpack_public_path__ + "static/media/logo.a8bf4971.svg";